function ham() {
    
// import ham from './modules/ham';

// window.addEventListener('DOMContentLoaded', () => {
//     menu();
//     ham();
    
//     new WOW().init();
//     SmoothScroll({
//         animationTime : 800,
//         stepSize : 75,
//         accelerationDelta : 30,
//         accelerationMax : 2,
//         keyboardSupport : true,
//         arrowScroll : 50,
//         pulseAlgorithm : true,
//         pulseScale : 4,
//         pulseNormalize : 1,
//         touchpadSupport : true,
//         })


// });
document.addEventListener('DOMContentLoaded', () => {
        const burger = document.querySelector('.header__burger');
    const mobileMenu = document.querySelector('.mobile-menu');

    burger.addEventListener('click', () => {
        burger.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        document.body.classList.toggle('menu-open');
    });

    const modal = document.querySelector('#callback-modal');





const openButtons = document.querySelectorAll('.js-open-modal');

const closeButton = document.querySelector('.modal__close');

const overlay = document.querySelector('.modal__overlay');

function openModal() {
    modal.classList.add('active');
    document.body.classList.add('modal-open');
}

function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
}

openButtons.forEach(button => {
    button.addEventListener('click', openModal);
});

closeButton.addEventListener('click', closeModal);

overlay.addEventListener('click', closeModal);

document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
        closeModal();
    }
});




const quiz = document.querySelector('.quiz');

if (quiz) {

    const steps = document.querySelectorAll('.quiz__step');
    const progressFill = document.querySelector('.quiz__progress-fill');
    const currentStepText = document.querySelector('#quiz-current-step');

    let currentStep = 0;

    function updateProgress() {

        const progress =
            ((currentStep + 1) / steps.length) * 100;

        progressFill.style.width = `${progress}%`;

        currentStepText.textContent = currentStep + 1;
    }

    function showStep(index) {

        steps.forEach(step => {
            step.classList.remove('quiz__step--active');
        });

        steps[index].classList.add('quiz__step--active');

        updateProgress();
    }

    document.querySelectorAll('.quiz__step').forEach(step => {

        const radios =
            step.querySelectorAll('input[type="radio"]');

        const nextButton =
            step.querySelector('.quiz__button--next');

        if (!nextButton) return;

        radios.forEach(radio => {

            radio.addEventListener('change', () => {

                nextButton.disabled = false;

            });

        });

    });

    document.addEventListener('click', event => {

        if (
            event.target.classList.contains(
                'quiz__button--next'
            )
        ) {

            if (currentStep < steps.length - 1) {

                currentStep++;

                showStep(currentStep);

            }

        }

        if (
            event.target.classList.contains(
                'quiz__button--prev'
            )
        ) {

            if (currentStep > 0) {

                currentStep--;

                showStep(currentStep);

            }

        }

    });

    showStep(0);
}


const reviewsSlider = new Swiper('.reviews__slider', {
    loop: true,
    speed: 800,
    spaceBetween: 30,

    autoplay: {
        delay: 4500,
        disableOnInteraction: false,
    },

    pagination: {
        el: '.reviews__pagination',
        clickable: true,
    },

    navigation: {
        nextEl: '.reviews__next',
        prevEl: '.reviews__prev',
    },

    breakpoints: {
        320: {
            slidesPerView: 1
        },

        768: {
            slidesPerView: 2
        },

        1200: {
            slidesPerView: 3
        }
    }
});


const faqItems = document.querySelectorAll('.faq-item');

faqItems.forEach(item => {
    const header = item.querySelector('.faq-item__header');

    header.addEventListener('click', () => {

        faqItems.forEach(el => {
            if (el !== item) {
                el.classList.remove('active');
            }
        });

        item.classList.toggle('active');
    });
});

    const modal2 = document.querySelector('.certificates-modal');
    const openBtn = document.querySelector('.btn-certificates');
    const closeBtn = document.querySelector('.certificates-modal__close');

    openBtn.addEventListener('click', () => {
        modal2.classList.add('active');
        document.body.style.overflow = 'hidden';
    });

    closeBtn.addEventListener('click', () => {
        modal2.classList.remove('active');
        document.body.style.overflow = '';
    });

    modal2.addEventListener('click', (e) => {
        if (e.target === modal2) {
            modal2.classList.remove('active');
            document.body.style.overflow = '';
        }
    });

});

const tabs = document.querySelectorAll('.steps-tab');
const slides = document.querySelectorAll('.steps-slide');

tabs.forEach(tab => {
    tab.addEventListener('click', () => {

        const step = tab.dataset.step;

        tabs.forEach(btn => btn.classList.remove('active'));
        slides.forEach(slide => slide.classList.remove('active'));

        tab.classList.add('active');

        document
            .querySelector(`.steps-slide[data-step="${step}"]`)
            .classList.add('active');
    });
});
}

export default ham;